import {createModelSchema, alias, custom, deserialize, serialize, SKIP, list, object} from "serializr";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {Cloneable} from "@/common/Cloneable";

export class ChristmasTierEntry {
  constructor(minLevel = null, rewards = null) {
    this.minLevel = minLevel;
    this.rewards = rewards;
  }
}

createModelSchema(ChristmasTierEntry, {
  minLevel: alias(
    "minLevel",
    custom(
      v => (v == null ? null : Number(v) || 0),
      raw => (raw == null ? null : Number(raw) || 0),
    )
  ),
  rewards: alias("reward_track", RewardTrack.schema()),
});

export class ChristmasTierLevels extends Cloneable {
  constructor() {
    super();

    this._lowMinLvl = null;
    this._midMinLvl = null;
    this._highMinLvl = null;

    this._lowReward = null;
    this._midReward = null;
    this._highReward = null;

    this._lowTiers = [];
    this._midTiers = [];
    this._highTiers = [];
  }

  static schema() {
    return custom(
      (v) => (v ? serialize(ChristmasTierLevels, v) : SKIP),
      (v) => deserialize(ChristmasTierLevels, v),
    );
  }

  get lowMinLvl() {
    return this._lowMinLvl;
  }
  set lowMinLvl(value) {
    this._lowMinLvl = Number(value) || 0;
  }

  get midMinLvl() {
    return this._midMinLvl;
  }
  set midMinLvl(value) {
    this._midMinLvl = Number(value) || 0;
  }

  get highMinLvl() {
    return this._highMinLvl;
  }
  set highMinLvl(value) {
    this._highMinLvl = Number(value) || 0;
  }

  get lowReward() {
    return this._lowReward;
  }
  set lowReward(value) {
    this._lowReward = value;
  }

  get midReward() {
    return this._midReward;
  }
  set midReward(value) {
    this._midReward = value;
  }

  get highReward() {
    return this._highReward;
  }
  set highReward(value) {
    this._highReward = value;
  }

  get tier_low() {
    return this._lowTiers;
  }
  set tier_low(arr) {
    this._lowTiers = arr || [];

    const first = this._lowTiers[0];
    this._lowMinLvl = first ? first.minLevel : null;
    this._lowReward = first ? first.rewards : null;
  }

  get tier_mid() {
    return this._midTiers;
  }
  set tier_mid(arr) {
    this._midTiers = arr || [];

    const first = this._midTiers[0];
    this._midMinLvl = first ? first.minLevel : null;
    this._midReward = first ? first.rewards : null;
  }

  get tier_high() {
    return this._highTiers;
  }
  set tier_high(arr) {
    this._highTiers = arr || [];

    const first = this._highTiers[0];
    this._highMinLvl = first ? first.minLevel : null;
    this._highReward = first ? first.rewards : null;
  }

  _validateTierArray(arr) {
    if (!arr || !arr.length) {
      return false;
    }

    for (const entry of arr) {
      const lvl = entry.minLevel;
      const reward = entry.rewards;

      if (!Number.isInteger(lvl) || lvl < 0) {
        return false;
      }

      if (!reward || reward.empty() || !reward.valid()) {
        return false;
      }
    }

    return true;
  }

  valid() {
    if (!this._validateTierArray(this._lowTiers)) {
      return false;
    }

    if (!this._validateTierArray(this._midTiers)) {
      return false;
    }

    if (!this._validateTierArray(this._highTiers)) {
      return false;
    }

    return true;
  }
}

createModelSchema(ChristmasTierLevels, {
  tier_low:  alias("tier_low", list(object(ChristmasTierEntry))),
  tier_mid:  alias("tier_mid", list(object(ChristmasTierEntry))),
  tier_high: alias("tier_high", list(object(ChristmasTierEntry))),
});
